import React from 'react';
import { Box, Typography } from '@mui/material';
import { themeColors } from '../styles/theme';

/**
 * Animated audio playing indicator component
 */
export const AudioPlayingIndicator = ({ isPlaying }) => (
  <Box sx={{ display: 'flex', alignItems: 'center', gap: 1 }}>
    {isPlaying && (
      <Box sx={{ 
        display: 'flex', 
        alignItems: 'flex-end', 
        gap: 0.5,
        height: 16,
        px: 0.5
      }}>
        <Box sx={{
          width: 3,
          height: 8,
          bgcolor: themeColors.primary,
          borderRadius: 1.5,
          animation: 'audioPulse 1s ease-in-out infinite',
          '@keyframes audioPulse': {
            '0%, 100%': { transform: 'scaleY(0.4)', opacity: 0.7 },
            '50%': { transform: 'scaleY(1)', opacity: 1 }
          }
        }} />
        <Box sx={{ 
          width: 3, 
          height: 12, 
          bgcolor: themeColors.primary, 
          borderRadius: 1.5, 
          animation: 'audioPulse 1s ease-in-out infinite 0.2s',
          '@keyframes audioPulse': {
            '0%, 100%': { transform: 'scaleY(0.4)', opacity: 0.7 },
            '50%': { transform: 'scaleY(1)', opacity: 1 }
          }
        }} />
        <Box sx={{ 
          width: 3, 
          height: 10, 
          bgcolor: themeColors.primary, 
          borderRadius: 1.5, 
          animation: 'audioPulse 1s ease-in-out infinite 0.4s',
          '@keyframes audioPulse': {
            '0%, 100%': { transform: 'scaleY(0.4)', opacity: 0.7 },
            '50%': { transform: 'scaleY(1)', opacity: 1 }
          }
        }} />
        <Box sx={{ 
          width: 3, 
          height: 12, 
          bgcolor: themeColors.primary, 
          borderRadius: 1.5, 
          animation: 'audioPulse 1s ease-in-out infinite 0.6s',
          '@keyframes audioPulse': {
            '0%, 100%': { transform: 'scaleY(0.4)', opacity: 0.7 },
            '50%': { transform: 'scaleY(1)', opacity: 1 }
          }
        }} />
      </Box>
    )}
  </Box>
);

